import { detectBillingPlatform } from './platform/detect';

const DEVICE_ID_KEY = 'pouches_billing_device_id';

export function getBillingApiBase(): string {
  return 'https://apps.tomippe.jp/pouches/api/billing';
}

/** クロスオリジン時は credentials を付けない（CORS / Failed to fetch 回避） */
export function getBillingFetchCredentials(): RequestCredentials {
  if (typeof window === 'undefined') return 'omit';
  try {
    return new URL(getBillingApiBase()).origin === window.location.origin ? 'include' : 'omit';
  } catch {
    return 'omit';
  }
}

export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing && /^[0-9a-f-]{36}$/i.test(existing)) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

export interface BillingConfig {
  monthlyPriceLabel?: string;
}

let billingConfigPromise: Promise<BillingConfig> | null = null;

export async function loadBillingConfig(): Promise<BillingConfig> {
  if (!billingConfigPromise) {
    billingConfigPromise = fetch('/pouches/billing-config.json', { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : {}))
      .catch(() => ({}));
  }
  return billingConfigPromise;
}

export function isWebBillingPlatform(): boolean {
  const win = window as { electron?: unknown };
  if (win.electron) return false;
  return detectBillingPlatform() === 'web';
}

export async function isBillingPaywallEnabled(): Promise<boolean> {
  return true;
}
